export const DELETE_ARTEFACT_SUCCESS = "Objet décoratif supprimé avec succès !";
export const UPDATE_ARTEFACT_SUCCESS = "Objet décoratif modifié avec succès !";
export const ADD_ARTEFACT_SUCCESS = "Objet décoratif ajouté avec succès !";


// WEBPACK FOOTER //
// ./src/successes/artefacts.js